<template>
  <div
    :class="categoryLoading['pageLoading'] && 'bg-white'"
    class="flex-auto px-4 lg:px-10 pt-0"
  >
    <div
      v-if="categoryLoading['pageLoading']"
      class="bg-white w-full flex flex-col py-10 justify-center items-center"
    >
      <!-- https://gannon.tv/intro -->
      <img width="260" src="@/assets/imgs/loading.gif" alt="loading" />
      <h3>Loading...</h3>
    </div>
    <form class="w-full" v-else>
      <div class="flex flex-wrap mb-7">
        <div
          v-for="(value, name) in categoryAttributes"
          :key="name"
          class="w-full"
        >
          <div v-if="value.type === 'short_text'" class="relative w-full mb-3">
            <label
              :title="value.description"
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              v-model="formDataLocal['category_page']['attributes'][name]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div v-else-if="value.type === 'select'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <select
              v-model="formDataLocal['category_page']['attributes'][name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            >
              <option
                v-for="(option, index) in changeOptionsFormat(value.options)"
                :key="index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div
            v-else-if="
              value.type === 'boolean' && name === 'abi_cat_ribbon_custom'
            "
          >
            <div class="w-full flex items-center">
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <ToggleBtn
                class="ml-4"
                :status="formDataLocal['category_page']['attributes'][name]"
                @update:status="handleUpdateStatus($event, name)"
              />
            </div>
          </div>
          <div v-else-if="value.type === 'cat_slug_str'">
            <div
              v-if="
                formDataLocal['category_page']['attributes'][
                  'abi_cat_ribbon_custom'
                ] === 'yes'
              "
              class="relative w-full mb-3"
            >
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <SearchAndMultiSelect
                :options="categoryOptions"
                :label="'label'"
                :handleUpdate="handleUpdate"
                :selected="multiSelect"
                :handleInput="handleInput"
              />
            </div>
          </div>
          <div
            v-else-if="
              value.type === 'boolean' && name === 'abi_cat_intro_toggle'
            "
            class="mt-4"
          >
            <div class="w-full flex items-center">
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold"
              >
                <AttrTitleWithDescription
                  :title="formatAttrName(name)"
                  :description="value.description"
                />
              </label>
              <ToggleBtn
                class="ml-4"
                :status="formDataLocal['category_page']['attributes'][name]"
                @update:status="handleUpdateStatus($event, name)"
              />
            </div>
          </div>
          <div v-else-if="value.type === 'cat_shortcode'">
            <!-- intro shortcode -->
            <div
              v-if="
                formDataLocal['category_page']['attributes'][
                  'abi_cat_intro_toggle'
                ] === 'yes'
              "
              class="w-full mb-10 flex items-center flex-wrap"
            >
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold w-full"
              >
                <AttrTitleWithDescription
                  title="Intro Shortcode"
                  :description="value.description"
                />
              </label>
              <select
                v-model="selectedIntroComponentName"
                class="border-0 px-3 py-3 mr-4 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 w-full lg:w-4/12"
              >
                <option
                  v-for="(component, index) in this.componentNameList"
                  :key="index"
                  :value="`${component.name} name=${component.id}`"
                >
                  {{ component.name }}
                </option>
              </select>
              <div class="w-6">
                <IconSync v-if="getIntroLoading" class="animate-spin" />
              </div>
              <select
                v-model="selectedIntroInstanceName"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 w-full lg:w-4/12"
              >
                <option
                  v-for="(instance, index) in this.IntroInstanceList"
                  :key="index"
                  :value="instance.name"
                >
                  {{ instance.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="w-full mb-7 flex items-center">
        <label class="block uppercase text-blueGray-600 text-xs font-bold">
          <AttrTitleWithDescription
            title="Description Toggle"
            description="Show/Hide the whole description"
          />
        </label>
        <ToggleBtn
          class="ml-4"
          :status="formDataLocal['category_page']['attributes']['abi_cat_desc']"
          @update:status="handleUpdateStatus($event, 'abi_cat_desc')"
        />
      </div>

      <CategoryContentTextBlock
        v-for="(value, index) in ['overview', 'range', 'faqs', 'assistance']"
        :key="index"
        class="mb-10 shadow rounded-lg"
        :type="value"
        :formData="formDataLocal"
        :categoryName="categoryName"
        :componentName="'abi_content_text_block'"
      />
      <div class="w-full mb-10 flex items-center">
        <label class="block uppercase text-blueGray-600 text-xs font-bold">
          <AttrTitleWithDescription
            title="ABI Content Block Toggle"
            description="Show/Hide the Content Block"
          />
        </label>
        <ToggleBtn
          class="ml-4"
          :status="
            formDataLocal['category_page']['attributes'][
              'abi_cat_content_block'
            ]
          "
          @update:status="handleUpdateStatus($event, 'abi_cat_content_block')"
        />
      </div>
      <div
        class="w-full mb-10 flex items-center flex-wrap"
        v-if="
          formDataLocal['category_page']['attributes'][
            'abi_cat_content_block'
          ] === 'yes'
        "
      >
        <label
          class="block uppercase text-blueGray-600 text-xs font-bold w-full"
        >
          <AttrTitleWithDescription
            title="ABI Content Block Instance"
            description="Instance of ABI Content Block"
          />
        </label>
        <select
          v-model="selectedComponentName"
          class="border-0 px-3 py-3 mr-4 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 w-full lg:w-4/12"
        >
          <option
            v-for="(component, index) in this.componentNameList"
            :key="index"
            :value="`${component.name} name=${component.id}`"
          >
            {{ component.name }}
          </option>
        </select>
        <div class="w-6">
          <IconSync v-if="getLoading" class="animate-spin" />
        </div>
        <select
          v-model="selectedInstanceName"
          class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150 w-full lg:w-4/12"
        >
          <option
            v-for="(instance, index) in this.InstanceList"
            :key="index"
            :value="instance.name"
          >
            {{ instance.name }}
          </option>
        </select>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";
import SearchAndMultiSelect from "@/components/Shared/Input/SearchAndMultiSelect";
import ToggleBtn from "@/components/Shared/Input/ToggleBtn";
import CategoryContentTextBlock from "@/components/ComponentModule/CategoryComponent/CategoryContentTextBlock";
import IconSync from "@/assets/icons/IconSync";

export default {
  name: "CategoryForm",
  components: {
    CategoryContentTextBlock,
    ToggleBtn,
    AttrTitleWithDescription,
    SearchAndMultiSelect,
    IconSync
  },
  data() {
    return {
      multiSelect: [],
      selectedComponentName: "",
      selectedInstanceName: "",
      selectedIntroComponentName: "",
      selectedIntroInstanceName: ""
    };
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    componentId: {
      type: [String, null],
      required: true
    },
    categoryName: {
      type: String,
      required: true
    }
  },
  computed: {
    ribbonArray() {
      return this.formDataLocal["category_page"]["attributes"][
        "abi_cat_ribbon_arr"
      ];
    },
    introShortcode() {
      return this.formDataLocal["category_page"]["attributes"][
        "abi_cat_intro_shortcode"
      ];
    },
    contentBlockInstance() {
      return this.formDataLocal["category_page"]["attributes"][
        "abi_cat_content_block_instance"
      ];
    },
    categoryOptions() {
      return this.categorySlugOptions.map((item) => {
        return { label: item.name, name: item.name };
      });
    },
    categoryAttributes() {
      if (this.categoryAllAttributes[this.componentId]) {
        const allAttributes = this.categoryAllAttributes[this.componentId];
        const asArray = Object.entries(allAttributes);
        const filtered = asArray.filter(
          (item) =>
            item[0] === "abi_cat_tagline" ||
            item[0] === "abi_cat_ribbon_custom" ||
            item[0] === "abi_cat_ribbon_arr" ||
            item[0] === "abi_cat_intro_toggle" ||
            item[0] === "abi_cat_intro_shortcode"
        );
        return Object.fromEntries(filtered);
      } else {
        return {};
      }
    },
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    componentNameList() {
      if (this.getAllComponent.length) {
        return this.getAllComponent.map((item) => {
          return { id: item.id, name: item.name };
        });
      } else {
        return [];
      }
    },
    InstanceList() {
      if (this.getFilteredInstanceInfo) {
        return this.getFilteredInstanceInfo.map((item) => {
          return { id: item.id, name: item.instance_name };
        });
      } else {
        return [];
      }
    },
    IntroInstanceList() {
      if (this.getFilteredIntroInstanceInfo) {
        return this.getFilteredIntroInstanceInfo.map((item) => {
          return { id: item.id, name: item.instance_name };
        });
      } else {
        return [];
      }
    },
    ...mapGetters([
      "categoryLoading",
      "getAllComponent",
      "getFilteredInstanceInfo",
      "getFilteredIntroInstanceInfo",
      "categorySlugOptions",
      "categoryAllAttributes",
      "getLoading",
      "getIntroLoading",
      "getRegion"
    ])
  },
  emits: ["update:formData"],
  mounted() {
    this.setInitValues();
  },
  watch: {
    contentBlockInstance() {
      if (this.contentBlockInstance) {
        this.selectedComponentName = this.contentBlockInstance.split("|")[0];
      }
    },
    introShortcode() {
      if (this.introShortcode) {
        this.selectedIntroComponentName = this.introShortcode
          .split("|")[0]
          .replace("[", "");
      }
    },
    getFilteredInstanceInfo() {
      if (this.getFilteredInstanceInfo.length && this.contentBlockInstance) {
        this.selectedInstanceName =
          this.selectedComponentName.split("=")[1] +
          "|" +
          this.contentBlockInstance.split("|")[1];
      }
    },
    getFilteredIntroInstanceInfo() {
      if (this.getFilteredIntroInstanceInfo.length && this.introShortcode) {
        this.selectedIntroInstanceName =
          this.selectedIntroComponentName.split("=")[1] +
          "|" +
          this.introShortcode.split("|")[1].replace("]", "");
      }
    },
    ribbonArray() {
      if (this.ribbonArray) {
        let ribbonList = this.ribbonArray.split(",");
        this.multiSelect = ribbonList.map((item) => {
          return { label: item, name: item };
        });
      }
    },
    categoryAttributes() {
      this.setInitValues();
    },
    selectedComponentName() {
      if (this.selectedComponentName.split("=")[1]) {
        this.$store.dispatch(Actions.FETCH_INSTANCE_INFO, {
          region: this.getRegion,
          componentId: this.selectedComponentName.split("=")[1]
        });
      }
    },
    selectedInstanceName() {
      if (this.selectedComponentName[1] && this.selectedInstanceName) {
        this.formDataLocal["category_page"]["attributes"][
          "abi_cat_content_block_instance"
        ] =
          this.selectedComponentName.split("=")[0] +
          "=" +
          this.selectedInstanceName;
      }
    },
    selectedIntroComponentName() {
      if (this.selectedIntroComponentName.split("=")[1]) {
        this.$store.dispatch(Actions.FETCH_INTRO_INSTANCE_INFO, {
          region: this.getRegion,
          componentId: this.selectedIntroComponentName.split("=")[1]
        });
      }
    },
    selectedIntroInstanceName() {
      if (
        this.selectedIntroComponentName[1] &&
        this.selectedIntroInstanceName
      ) {
        this.formDataLocal["category_page"]["attributes"][
          "abi_cat_intro_shortcode"
        ] =
          "[" +
          this.selectedIntroComponentName.split("=")[0] +
          "=" +
          this.selectedIntroInstanceName +
          "]";
      }
    }
  },
  methods: {
    setInitValues() {
      if (Object.keys(this.categoryAttributes).length) {
        // initiate the form data when attrubutes are ready
        Object.keys(this.categoryAttributes).forEach((key) => {
          if (!this.formDataLocal["category_page"]["attributes"][key]) {
            this.formDataLocal["category_page"]["attributes"][key] =
              this.categoryAttributes[key].value || "";
          }
        });
      }
    },
    handleInput(value) {
      this.$store.dispatch(Actions.CATEGORY_OPTIONS_SEARCH, value);
    },
    handleUpdate(value) {
      this.multiSelect =
        this.multiSelect.filter((t) => t.name === value.name).length > 0
          ? this.multiSelect.filter((t) => t.name !== value.name)
          : [...this.multiSelect, value];
      this.formDataLocal["category_page"]["attributes"][
        "abi_cat_ribbon_arr"
      ] = `${this.multiSelect.map((item) => {
        return item.name;
      })}`;
    },
    handleUpdateStatus(val, name) {
      this.formDataLocal["category_page"]["attributes"][name] = val;
    },
    formatAttrName(name) {
      const nameArray = name.split("_");
      nameArray.splice(0, 2);
      return nameArray.join(" ");
    },
    changeOptionsFormat(options) {
      const newOptions = options.map((item) => {
        return { label: item, value: item };
      });
      return newOptions;
    }
  }
};
</script>
